/**
 * Home page translations
 * Includes: Home content, pull to refresh, list loading
 */
export default {
  randomMatchButton: {
    title: 'Random Match',
    eachCost: '{cost}/Time',
  },
}
